module.exports = {"slider":{"labels":{"loading":"Composant Slider en cours de préparation","portraitImage":"Format portrait","landscapeImage":"Format paysage","dropFile":"Déposer un fichier (cliquer glisser)"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/Slider/admin-fr.json
// module id = c/wM
// module chunks = 18